export default __webpack_public_path__ + "static/media/Neophyte's Bracers of Secret Doors.f2e009d8.jpg";